import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Box, Collapse, Icon, Link, Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useIsMobile } from "src/hooks/useIsMobile";
import WhiteCard from "src/shared/components/WhiteCard";

interface Props {
  q: {
    question: string;
    answer: string;
  };
  handleDisplayAnswer: (q: string) => void;
  displayAnswer: string | null;
}

const Content = ({ q, handleDisplayAnswer, displayAnswer }: Props) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  return (
    <WhiteCard>
      <Stack gap={1}>
        <Box
          display="flex"
          justifyContent="space-between"
          onClick={() => handleDisplayAnswer(q.question)}
          sx={{ cursor: "pointer" }}
        >
          <Typography variant={isMobile ? "body2" : "body1"}>
            {t(q.question)}
          </Typography>
          <Icon sx={{ color: "#00B6B9" }}>
            {displayAnswer === q.question ? (
              <KeyboardArrowUp />
            ) : (
              <KeyboardArrowDown />
            )}
          </Icon>
        </Box>
        <Collapse
          in={displayAnswer === q.question}
          timeout="auto"
          unmountOnExit
        >
          <Typography variant="subtitle2">
            <Trans
              i18nKey={q.answer}
              components={{
                mailto: <Link href="mailto:support@holavida.com" />,
                "unordered-list": <ul />,
                "list-item": <li />,
                bold: <strong />,
              }}
            />
          </Typography>
        </Collapse>
      </Stack>
    </WhiteCard>
  );
};

export default Content;
